<template>
    <!-- The organisation's address and contacts at the foot of printed documents (Settings >
         بيانات المؤسسة), only the ones that are filled in. id and class given by the page land on
         this element: the documents use id="footer" to print with or without it (they toggle
         .no-print on it). Nothing is drawn, not even the rule above it, while all are empty. -->
    <footer v-show="items.length" class="print-footer">
        <p class="print-footer__line">
            <span v-for="item in items" :key="item.key" :dir="item.dir">{{ item.text }}</span>
        </p>
    </footer>
</template>

<script>
export default {
    computed: {
        org() {
            return this.$store.state.organization.org;
        },
        // Right to left on paper: the Arabic address first, the English one last.
        items() {
            const org = this.org;
            return [
                { key: "addressAr", text: org.addressAr, dir: null },
                { key: "phone", text: org.phone, dir: "ltr" },
                { key: "email", text: org.email, dir: "ltr" },
                { key: "website", text: org.website, dir: "ltr" },
                { key: "addressEn", text: org.addressEn, dir: "ltr" },
            ].filter(item => item.text);
        },
    },
};
</script>

<style scoped>
.print-footer {
    text-align: center;
    border-top: 1px solid;
    background-color: #fff;
}

.print-footer__line {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 0 12px;
    margin: 0;
    font-size: 12.5px;
    text-align: center;
}
</style>
